import { useMemo } from 'react'
import { useWebSocketStore } from './websocket/useWebsocket'

export type RunStatus = {
  run_id?: string
  created_by?: string | null
  state: string
  created_at?: string
  updated_at?: string
}

function generateUserRunState(runStatus: RunStatus[]) {
  const username = localStorage.getItem('user') || ''
  if (!runStatus?.length || !username) return { pendingRun: null, hasInProgressRuns: false, username: '' }
  const userRuns = runStatus.filter((run) => run.created_by === username)
  const pendingRun = userRuns.find((run) => run.state === 'pending')?.run_id || null
  const hasInProgressRuns = userRuns.some((run) => run.state === 'in progress')
  const buildingRuns = userRuns.filter((run) => run.state === 'building') || []
  return { pendingRun, hasInProgressRuns, buildingRuns, username }
}

export const useRouteOptimization = () => {
  const runStatus = useWebSocketStore((state) => state().runStatus)
  const userRunState = useMemo(() => generateUserRunState(runStatus), [runStatus])

  return {
    runStatus,
    userRunState,
  }
}
